import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { LocalNotifications, LocalNotificationSchema } from "@capacitor/local-notifications";
import { App as AppPlugin } from "@capacitor/app";
import dayjs from "dayjs";
import { history } from "../providers/Redux/Reducers/history";
import {
  addLocalNotifications,
  cancelAllLocalNotifications,
  clearLocalNotifications,
} from "../utils/local-notifications";
import { useConfig } from "../providers/config";
import { useTranslation } from "react-i18next";
import { useCartData } from "../providers/cartDataStore";

const useInitCartRemindLocalNotifications = () => {
  const config = useConfig();
  const { t } = useTranslation();
  const { getCartTotal } = useCartData();

  useEffect(() => {
    if (config && Capacitor.isNativePlatform() && config.isLocalNotificationsEnabled) {
      const delayMinutes = config?.notifications?.cartRemindDelayMinutes;

      const initLocalPushes = async () => {
        const notificationPermissions = (await LocalNotifications.checkPermissions()).display;

        if (delayMinutes) {
          AppPlugin.addListener("pause", async () => {
            const getCartTotalValue = getCartTotal();

            if (getCartTotalValue > 0) {
              const notifications: LocalNotificationSchema[] = [
                {
                  id: dayjs().unix(),
                  schedule: {
                    at: dayjs().add(delayMinutes, "m").toDate(),
                    allowWhileIdle: true,
                  },
                  title: t("Goods in the cart"),
                  body: t("There are products left in your shopping cart. Click to complete your order."),
                  extra: {
                    type: "OPEN_CART",
                  },
                },
              ];
              // Cancel any existing cart notifications before scheduling a new one
              await cancelAllLocalNotifications();
              await addLocalNotifications(notifications);
            }
          });

          AppPlugin.addListener("resume", async () => {
            if ((await notificationPermissions) === "granted") {
              cancelAllLocalNotifications();
              clearLocalNotifications();
            }
          });
        }

        LocalNotifications.addListener("localNotificationActionPerformed", (actionPerformed) => {
          if (actionPerformed.notification.extra.type === "OPEN_CART") {
            history.push("/cart", { from: "notification" });
          }
        });
      };

      initLocalPushes();
    }
  }, [config, getCartTotal, t]);
};

export default useInitCartRemindLocalNotifications;
